import React, { useState } from "react";
import {
  FilterByStatus,
  floatDistributionData,
  floatRequestMetrics,
  getFloatRequestSummary,
} from "./data";
import PageStyle from "../../../Components/Layout/PageLayout";
import {
  CalendarFilter2,
  ProDropFilter,
  SearchFilter,
} from "../../../Components/Search/Search";
import { useSearchFilter } from "../../../../../utils/functions/useDate";
import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import { CTAButtons } from "../../../../global/components/Buttons/buttons";
import { useGetEmployeeFloatDashboardQuery } from "../../../../api/employeeFloat";
import { useNavigate } from "react-router";

const MetricCard = ({ title, value, icon }) => {
  return (
    <div className="bg-[#FFFFFF] w-full h-[134px] p-5 space-y-4 shadow-md rounded-md">
      <div className="mr-4">{icon}</div>
      <div>
        <p className="text-[18px] font-[600] text-[#29382A]">{value}</p>
        <h3 className="text-[14px] font-[400] text-[#666060]">{title}</h3>
      </div>
    </div>
  );
};

const DistributionCard = ({ title, value, color }) => {
  return (
    <div className="w-full p-5 space-y-4 border-r-1">
      <div className="flex items-center space-x-3">
        <div
          className="w-[10px] h-[10px] rounded-md"
          style={{
            backgroundColor: `${color}`,
          }}
        />
        <div>
          <p>{title}</p>
        </div>
      </div>
      <div>
        <h4 className="text-[18px] font-[600] text-[#29382A]">{value}</h4>
      </div>
    </div>
  );
};
const FloatReqestIndex = () => {
  const {
    searchText,
    setSearchText,
    pageSize,
    setPageSize,
    setCurrentPage,
    currentPage,
    filter,
    setFilter,
  } = useSearchFilter({
    initialFilter: 1,
  });
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
  const [activeTab, setActiveTab] = React.useState("FloatRequests");
  function createYearArray() {
    const currentYear = new Date().getFullYear();
    const lowestYear = 2002;
    const years = [];

    for (let year = currentYear; year >= lowestYear; year--) {
      years.push(year);
    }

    return years;
  }
  const navigate = useNavigate();
  const yearArray = createYearArray();
  const actionButton = (
    <>
      <CTAButtons
        onClick={() =>
          navigate(
            "/dashboard/employee/employee-float-request/add-employee-float-request"
          )
        }
      >
        New Request
      </CTAButtons>
    </>
  );
  const { data: metrics } = useGetEmployeeFloatDashboardQuery({
    year: currentYear,
  });
  const floatRequestMetrics = getFloatRequestSummary(
    metrics?.responseObject?.costOfAcquisition,
    metrics?.responseObject?.costOfRetention,
    metrics?.responseObject?.totalFloatUtilized,
    metrics?.responseObject?.floatROI,
    metrics?.responseObject?.budgetUtilized
  );
  return (
    <PageStyle
      hasBack={false}
      demoTitle={"EMPLOYEE FLOAT REQUEST"}
      hasTopPageDemo
    >
      <div>
        <div className="flex justify-between items-center">
          <div className="w-full">
            <h2 className="text-[#4B664C] text-[23px] font-[500]">Float</h2>
          </div>
          <div className="flex items-center w-auto">
            <select
              className="border border-customGreen py-3 text-baseFont outline-none focus:ring-0 rounded-md w-[120px]"
              onChange={(e) => {
                setCurrentYear(e.target.value);
              }}
            >
              {yearArray.map((year, index) => (
                <option className="w-full" key={index} value={year}>
                  {year}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="lg:flex grid grid-cols-3 items-center space-y-3 space-x-3">
          {floatRequestMetrics.map((metric, index) => (
            <MetricCard
              key={index}
              title={metric.title}
              value={
                metric.isPercentage ? `%${metric.value}` : `₦${metric.value}`
              }
              icon={
                <img
                  src={metric.icon}
                  className="w-[30px] h-[30px]"
                  alt={metric.title}
                />
              }
            />
          ))}
        </div>
        <div className="mt-10">
          <div>
            <h4 className="text-[#4B664C] text-[20px] font-[500]">
              Float Type Distribution (YTD)
            </h4>
          </div>
          <div className="lg:flex grid grid-cols-3 items-center space-y-3 space-x-3">
            {floatDistributionData.map((data, index) => (
              <DistributionCard
                key={index}
                title={data.title}
                value={data.value}
                color={data.color}
              />
            ))}
          </div>
        </div>
        <div>
          <div className="mb-4">
            <div style={{ display: "flex", borderBottom: "1px solid #305F32" }}>
              <button
                type="button"
                onClick={() => setActiveTab("FloatRequests")}
                style={{
                  padding: "10px 20px",
                  border: "none",
                  borderBottom:
                    activeTab === "FloatRequests"
                      ? "2px solid #305F32"
                      : "none",
                  background: "none",
                  cursor: "pointer",
                  fontWeight: activeTab === "FloatRequests" ? "bold" : "normal",
                }}
              >
                Float Requests{" "}
                <span
                  style={{
                    backgroundColor:
                      activeTab === "FloatRequests" ? "#305F32" : "#EFF6F0",
                    color: activeTab === "FloatRequests" ? "white" : "#6E9170",
                    borderRadius: "50%",
                    padding: "2px 8px",
                    marginLeft: "8px",
                    fontSize: "12px",
                  }}
                >
                  8
                </span>
              </button>
              <button
                type="button"
                onClick={() => setActiveTab("OutstandingRequests")}
                style={{
                  padding: "10px 20px",
                  border: "none",
                  borderBottom:
                    activeTab === "OutstandingRequests"
                      ? "2px solid #305F32"
                      : "none",
                  background: "none",
                  cursor: "pointer",
                  fontWeight:
                    activeTab === "OutstandingRequests" ? "bold" : "normal",
                }}
              >
                Outstanding Requests{" "}
                <span
                  style={{
                    backgroundColor:
                      activeTab === "OutstandingRequests"
                        ? "#305F32"
                        : "#EFF6F0",
                    color:
                      activeTab === "OutstandingRequests" ? "white" : "#6E9170",
                    borderRadius: "50%",
                    padding: "2px 8px",
                    marginLeft: "8px",
                    fontSize: "12px",
                  }}
                >
                  8
                </span>
              </button>
            </div>
          </div>
          <div className="flex justify-between items-center">
            <form className={DashboardStyle.dashboard_filter}>
              <SearchFilter
                value={searchText}
                text={(searchText) => setSearchText(searchText)}
              />
              <CalendarFilter2
                name="Select Date Range"
                setStartDate={setStartDate}
                setEndDate={setEndDate}
                normalDate
              />
              <ProDropFilter
                filter={filter}
                setFilter={setFilter}
                name={"Status"}
                filterBy={FilterByStatus}
              />
            </form>
            <div>{actionButton}</div>
          </div>
        </div>
      </div>
    </PageStyle>
  );
};

export default FloatReqestIndex;
